(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/news/views/news-list.js') >= 0) return;  svs.modules.push('/components/sport/news/views/news-list.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.sport=_svs.sport||{};
_svs.sport.news=_svs.sport.news||{};
_svs.sport.news.templates=_svs.sport.news.templates||{};
svs.sport.news.templates.news_list = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"news\">\n  <h1>"
    + container.escapeExpression(((helper = (helper = helpers.header || (depth0 != null ? depth0.header : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"header","hash":{},"data":data}) : helper)))
    + "</h1>\n  <ul class=\"news-list list-style-none\">\n  </ul>\n</div>\n";
},"useData":true});
Handlebars.partials['components-sport-news-news_list'] = svs.sport.news.templates.news_list;
})(svs, Handlebars);

 })(window);